import type { FaireProductEntity } from "../../entity_types/product";

export const p_7hgsrgbt3w: FaireProductEntity = {
  token: "p_7hgsrgbt3w",
  type: "product",
  name: "The Tea Bowl",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/2eaae589f73e0834dd796afba8127c78241d2d2e1de012b3160af30d574a10ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1f0e7de0a1dab2dc613a9293ff974bf33ecb29c117f69403032cefe73a146b6.png",
    "https://cdn.faire.com/fastly/a9dec09828abbd925a720b387c8f04647102c877f562691a5949ea591a31b25f.jpeg"
  ],
  priceDollars: 13,
  description: "Double Walled Glass Tea Bowl \n\nSip stunningly in this clear, comfortable and stunning to sip from. She's spacious, she's gorgeous and you'll want to enjoy your tea in her everyday!\n\nMade with double-sided glass, it protects your hands from the heat and sheer glass shows off your gorgeous latte or favourite tea. \n\n473 ml / 2 cups - Glass\n\nCare instructions \n\nDishwasher friendly.",
  tags: [],
  msrpDollars: 24,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:41.310Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
